// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-33lsG";
var _3 = "wrapper-2K20v";
var _4 = "item-23U1m";
export { _1 as "__esModule", _2 as "container", _3 as "wrapper", _4 as "item" }
export default { "__esModule": _1, "container": _2, "wrapper": _3, "item": _4 }
